/** @format */

const _ = require('underscore');

export class GeneralHelper {
    static getString(obj, field) {
        let f = '';
        if (_.has(obj, field)) {
            f = obj[field];
        }
        return f;
    }

    static isEntityChange = (primaryObj, entityObject, component, callBack) => {
        const change = {};
        for (const key in primaryObj) {
            if (primaryObj[key] !== entityObject[key]) {
                change[key] = entityObject[key];
            }
        }
        const isChange = !_.isEmpty(change);
        component.setState({ change: isChange, entityChange: change }, () => {
            if (callBack) {
                callBack(isChange);
            }
        });
    };

    static setActiveRow = (id, component, stateName = 'activeRow') => {
        if (component.state[stateName] === id) {
            id = null;
        }
        component.setState(() => ({
            [stateName]: id,
        }));
    };

    static sort = (a, b, property, order = 'asc') => {
        if (order === 'asc') {
            return a[property].toLowerCase().trim() > b[property].toLowerCase().trim() ? 1 : -1;
        } else {
            return a[property].toLowerCase().trim() < b[property].toLowerCase().trim() ? 1 : -1;
        }
    };

    static capitalize = (text) => {
        return text[0].toUpperCase() + text.slice(1);
    };
}
